"use strict";

var Tooltips = function () {

    var handleTooltips = function () {

        if($("#form_submit").length > 0) {
            $('#form_submit input').keydown(function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                    return false;
                }
            });
        }

        $('#page-content .cms a').each(function() {
            var href = $(this).attr("href");
            if (href !== undefined && (href.indexOf("http://") >= 0 || href.indexOf("https://") >= 0)) {
                var host = location.host;
                host = host.replace(/^www\./i, "");
                host = host.replace(/^.*?([^.]+\.[^.]+)$/, "$1");
                if(href.indexOf(host) == -1) {
                    $(this).attr('target','_blank');
                    $(this).attr('rel','noopener noreferrer');
                }
            }
        });

        tippy('.tooltip-title', {
            content(reference) {
                const data = reference.getAttribute('data-template');
                let result = '';
                if (data) {
                    const template = document.getElementById(data);
                    result = template.innerHTML;
                    reference.removeAttribute('data-template');
                } else {
                    result = reference.getAttribute('data-title');
                    if (result) {
                        result = '<p>' + result + '</p';
                        reference.removeAttribute('data-title');
                    }
                }
                return result;
            },
            onCreate(instance) {
                if (!instance.props.content) {
                    instance.destroy();
                }
            },
            theme: 'light',
            allowHTML: true,
        });

    };

    return {
        //main function to initiate the function
        init: function() {
            handleTooltips();
        }
    };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = Tooltips;
}

jQuery(document).ready(function() {
    Tooltips.init();
});
